module.exports = __webpack_public_path__ + "static/media/jinlei.5a540ebe.jpg";